import api from './api';
export const policyService = {
    // Create a new policy
    createPolicy(data) {
        return api.post('/api/policies/policy', data);
    },
    // Fetch a single policy by ID
    getPolicy(id) {
        return api.get(`/api/policies/policy/${id}`);
    },
    // Update an existing policy by ID
    updatePolicy(id, data) {
        return api.put(`/api/policies/policy/${id}`, data);
    },
    // Optional: delete a policy by ID
    deletePolicy(id) {
        return api.delete(`/api/policies/policy/${id}`);
    },
};
